var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgE911Emergency = function SvgE911Emergency(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.346 19.5V18H6.88l1.927-6.46a1.7 1.7 0 0 1 .656-.942 1.8 1.8 0 0 1 1.077-.349h2.922a1.8 1.8 0 0 1 1.078.35q.483.348.655.94L17.121 18h1.533v1.5zM11.25 7.94v-4.5h1.5v4.5zm5.7 2.37-1.07-1.07 3.195-3.169 1.044 1.044zm1.3 4.63v-1.5h4.5v1.5zm-11.2-4.63L3.88 7.116l1.045-1.044 3.194 3.17zm-5.8 4.63v-1.5h4.5v1.5z"
  })));
};
export default SvgE911Emergency;